import { IUserSettings } from 'APP/model/calendar/calendar.types';
import { calendarModel } from 'APP/model/model';

export const getUserSettings = async (): Promise<IUserSettings | null> => {
  try {
    const response = await calendarModel.getUserCalendarSettings();

    return response;
  } catch (error) {
    return null;
  }
};
